export var DateTimeFormatterType;
(function (DateTimeFormatterType) {
    DateTimeFormatterType["DATE"] = "date";
    DateTimeFormatterType["DATE_STAMP"] = "date_stamp";
    DateTimeFormatterType["DATE_TIME"] = "date_time";
    DateTimeFormatterType["TIME"] = "time";
})(DateTimeFormatterType || (DateTimeFormatterType = {}));
